import { Col, Form, Row } from 'antd';
import React, { useContext, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import { dokumentZmenaStavuApi } from 'services/dokumenty/smlouva';

import { EStavZadostiDok } from 'enums/dokumentyEnums';
import { ENotificationType } from 'enums/notificationType';
import routePathEnum from 'enums/routePathEnum';

interface IZadostPosila {
    zadostID?: number;
    prevStep: () => void;
}

const ZadostPosila: React.FC<IZadostPosila> = ({ zadostID, prevStep }) => {
    const { aktivniFirma, profily, NotificationComponent } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper outForm={form} onFinish={() => {}}>
                <Title level={4} text={'PRIKAZ_PODAL'} />
                <InputComponent
                    label="JMENO"
                    name="jmeno"
                    type="text"
                    maxLength={100}
                    disabled={!!profily?.jmeno}
                    initialValue={profily?.jmeno}
                />
                <InputComponent
                    label="PRIJMENI"
                    name="prijmeni"
                    type="text"
                    maxLength={100}
                    disabled={!!profily?.prijmeni}
                    initialValue={profily?.prijmeni}
                />
                <Row className="button-row">
                    <Col>
                        <ButtonComponent buttontext="ZPET" onClick={prevStep} type="default" id="isinZpetBtn" />
                    </Col>
                    <Col>
                        <ButtonComponent
                            buttontext="ODESLAT"
                            onClick={() => {
                                setLoading(true);
                                dokumentZmenaStavuApi(zadostID!, EStavZadostiDok.AUTKONTROLA)
                                    .then(() => {
                                        NotificationComponent({
                                            type: ENotificationType.SUCCESS,
                                            description: 'LEI_SPARAVA_ZADOST_SUCCESS_TITLE'
                                        });
                                        navigateWorkaround(
                                            `/firma/${aktivniFirma?.iducet}${routePathEnum.DOKUMENTY_PREHLED}`
                                        );
                                    })
                                    .finally(() => setLoading(false));
                            }}
                            id="isinOdeslatBtn"
                        />
                    </Col>
                </Row>
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default ZadostPosila;
